import React from "react";

import AddForm from "../../../components/manageUsers/AddForm";
import { Container, Content, ContactBox } from "./style";
import Title from "../../../components/defaultComponents/Title";

export default function Form() {
  return (
    <Container>
      <Content>
        <Title>Cadastrar Novo Usuário</Title>
        <ContactBox>
          <AddForm />
        </ContactBox>
      </Content>
    </Container>
  );
}
